export default {
  title: (
    <>
      Invita i tuoi amici e <br /> raccogliere i premi insieme
    </>
  ),
  textButton: 'Per saperne di più',
};
